import React, { useEffect } from 'react';


const OtpTimer = (props) => {
const {timer,setCanResend,resendCount,setTimer} = props


  useEffect(() => {
    let interval;

    if (timer > 0 && resendCount < 5) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } 
    else{
      setCanResend(false);
    } 
    
    return () => {  
      clearInterval(interval);
    };
  }, [timer, resendCount]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  return (
      
    <div>
        <span disabled={timer > 0}>
        Time Remaining {(formatTime(timer))} 
        </span>  
    </div>
  );

};

export default OtpTimer;
